import { getEnv } from "../config/env";

// Data root and API endpoints come from Vite env variables (REACT_APP_ prefix, see .env.example).
const env = import.meta.env;

const withTrailingSlash = (url) => (url.endsWith("/") ? url : `${url}/`);

/**
 * Root URL of the published data (the pipeline's data/webdata, served by server/data-site). Local runs
 * read `wrangler dev` on port 7071; deployed apps read the data site.
 */
function getDataUrl() {
  if (env.REACT_APP_DATA_URL) {
    return withTrailingSlash(env.REACT_APP_DATA_URL);
  }
  const environment = getEnv();
  return environment === "dev" || environment === "test" ? "http://localhost:7071/" : "https://data.newstatements.com/";
}

/**
 * Where the client reads the data: "pages" from the prerendered pages that carry it (deployed site, no JSON
 * published), "files" from the JSON files at the data URL (local runs, or a data API later). Set with
 * REACT_APP_DATA_SOURCE.
 */
function getDataSource() {
  if (env.REACT_APP_DATA_SOURCE === "pages" || env.REACT_APP_DATA_SOURCE === "files") {
    return env.REACT_APP_DATA_SOURCE;
  }
  const environment = getEnv();
  return environment === "dev" || environment === "test" ? "files" : "pages";
}

export const apis = {
  dataApi: {
    source: getDataSource(),
    endpoint: getDataUrl(),
  },
  // Watchlists need a backend that does not exist yet: without REACT_APP_API_URL their calls return null
  // without any request.
  watchlistsApi: env.REACT_APP_API_URL
    ? {
        endpoint: withTrailingSlash(env.REACT_APP_API_URL),
        apiVersion: "2022-05-09",
        subscriptionKey: env.REACT_APP_APIM_SUBSCRIPTION_KEY || null,
      }
    : null,
};
